import { EnvironmentSetting } from './../models/plan/environmentSetting';
import { FukuchaDetail } from './../fukusha/model/fukushaDetail';
import { apiUrl, apiUrlcommon } from './../app.config';
import { Fukusha } from './../fukusha/model/fukusha';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import {
  Http,
  Response,
  URLSearchParams,
  Headers,
  RequestOptionsArgs,
  RequestOptions
} from '@angular/http';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class FukushaService {
  public defaultHeaders: Headers = new Headers();
  constructor(private _http: Http, private router: Router, private _data: DataService) { }

  getFukusha(): Observable<Fukusha[]> {
    const path = `${apiUrl}` + `/fukusha/list`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError);
  }

  getfukushaDetail(value: number, prefCd: any, taxRate: number): Observable<FukuchaDetail> {
    const path =
      `${apiUrl}` + `/fukusha/detail?q=fukushaCd=${value},prefCd=${prefCd},taxRate=${taxRate}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError);
  }

  getColorData(
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this._http
      .get(
        `${apiUrlcommon}/newcar/grades/colors/search1/?q=makerCd%3D${makerCd},modelCd%3D${modelCd},kaiseiYm%3D${kaiseiYm},gradeCd%3D${gradeCd}`,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getEnvironmentSettingdefault(): Observable<EnvironmentSetting> {
    const path = `${apiUrl}` + `/user/setting/environment`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  deleteToken() {
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this._http
        .delete(`${apiUrl}/auth/token`, { headers: headerParams })
        .subscribe(() => { });
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fukusha.service.ts